import Axios from 'axios';

class DocTypesApi {
  /**
   * Method used to login.
   *
   * @returns {Promise} The result in a promise.
   */
  static docTypes() {
    const session = JSON.parse(localStorage.getItem('session'));
    const config = {
      headers: { Authorization: `Bearer ${session.token}` },
      baseURL: process.env.API_DOCUMENTS_DESKRH,
      Accept: 'application/json',
    };
    const instance = Axios.create(config);
    return instance.get('/doc-types', config)
      .then(response => response.data.data);
  }

  static docTypesDeskDaf() {
    const session = JSON.parse(localStorage.getItem('sessionDeskDaf'));
    const config = {
      headers: { Authorization: `Bearer ${session.token}` },
      baseURL: process.env.API_DOCUMENTS_DESKDAF,
      Accept: 'application/json',
    };
    const instance = Axios.create(config);
    return instance.get('/doc-types', config)
      .then(response => response.data.data);
  }
}

export default DocTypesApi;



// WEBPACK FOOTER //
// ./src/api/DocTypesApi.js